import { render, staticRenderFns } from "./TeamsByTournament.vue?vue&type=template&id=e218044a&scoped=true"
import script from "./TeamsByTournament.vue?vue&type=script&lang=js"
export * from "./TeamsByTournament.vue?vue&type=script&lang=js"
import style0 from "./TeamsByTournament.vue?vue&type=style&index=0&id=e218044a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e218044a",
  null
  
)

export default component.exports